import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './TemplatesPage.css';

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading]     = useState(true);
  const navigate = useNavigate();

  const load = () => api.get('/contract-templates').then(d => { setTemplates(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  async function handleDelete(id, e) {
    e.stopPropagation();
    if (!window.confirm('Delete this template?')) return;
    await api.delete(`/contract-templates/${id}`);
    load();
  }

  return (
    <div className="templates-page">
      <div className="page-header">
        <div>
          <button className="back-link" onClick={() => navigate('/contracts')}>← Contracts</button>
          <h2>Contract Templates</h2>
        </div>
        <button className="btn-primary" onClick={() => navigate('/contracts/templates/new')}>+ New Template</button>
      </div>

      {loading ? <div className="loading">Loading…</div> : templates.length === 0 ? (
        <div className="empty-state">No templates yet. Create one to start generating contracts.</div>
      ) : (
        <div className="template-list">
          {templates.map(t => (
            <div key={t.id} className="template-card" onClick={() => navigate(`/contracts/templates/${t.id}/edit`)}>
              <div className="template-info">
                <span className="template-title">{t.title}</span>
                <span className="template-date">Updated {new Date(t.updatedAt).toLocaleDateString()}</span>
              </div>
              <div className="template-actions">
                <button className="btn-use" onClick={e => { e.stopPropagation(); navigate(`/contracts/new?templateId=${t.id}`); }}>
                  Use
                </button>
                <button className="btn-delete" onClick={e => handleDelete(t.id, e)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
